"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRangeCalendarStateReducer = exports.SET_HOVERED_DATE = exports.RESET = exports.CHANGE_RANGE_DATE_BY_INDEX = exports.CHANGE_FOCUSED_DATE = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RESET = exports.RESET = 'RESET';
var CHANGE_RANGE_DATE_BY_INDEX = exports.CHANGE_RANGE_DATE_BY_INDEX = 'CHANGE_RANGE_DATE_BY_INDEX';
var CHANGE_FOCUSED_DATE = exports.CHANGE_FOCUSED_DATE = 'CHANGE_FOCUSED_DATE';
var SET_HOVERED_DATE = exports.SET_HOVERED_DATE = 'SET_HOVERED_DATE';
var createRangeCalendarStateReducer = exports.createRangeCalendarStateReducer = function createRangeCalendarStateReducer(_ref) {
  var isSameView = _ref.isSameView,
    startOfView = _ref.startOfView;
  return function (state, action) {
    switch (action.type) {
      case SET_HOVERED_DATE:
        var newHoveredDate = action.payload.newHoveredDate;
        return _objectSpread(_objectSpread({}, state), {}, {
          lastFocusedOrHoveredDate: newHoveredDate
        });
      case RESET:
        {
          return _objectSpread(_objectSpread({}, action.payload), {}, {
            lastFocusedOrHoveredDate: action.payload.focusedDate
          });
        }
      case CHANGE_RANGE_DATE_BY_INDEX:
        {
          var _action$payload = action.payload,
            index = _action$payload.index,
            newDate = _action$payload.newDate,
            isFinish = _action$payload.isFinish;
          var range = state.range.map(function (d, i) {
            return i === index ? newDate : d;
          });
          if (isFinish) {
            var focusedDate = startOfView(newDate);
            // focus first item in last enabled view
            return _objectSpread(_objectSpread({}, state), {}, {
              range: range,
              focusedDate: focusedDate,
              lastFocusedOrHoveredDate: focusedDate
            });
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            range: range
          });
        }
      case CHANGE_FOCUSED_DATE:
        {
          var _action$payload2 = action.payload,
            _index = _action$payload2.index,
            newFocusedDate = _action$payload2.newFocusedDate;
          var needDateSwitch = state.range.every(function (m) {
            return !isSameView(m, newFocusedDate);
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            lastFocusedOrHoveredDate: newFocusedDate,
            focusedDate: newFocusedDate,
            range: needDateSwitch ? state.range.map(function (m, i) {
              return i === _index ? startOfView(newFocusedDate) : m;
            }) : state.range
          });
        }
      default:
        return state;
    }
  };
};